<template>
  <div>
    <StepsForWizard class="my-4 pb-3"
                    :ativo="passoAtivo"
                    :passos="passos"
                    tamanho="sm" />

    <div class="VincularSelo_header">
      <div class="row">
        <div class="col">
          <label class="label VincularSelo_title pl-2">
            Selo vinculador: {{ propSeloVinculador.num_selo }} - OS {{ propSeloVinculador.seloItemOs.ordemServicoItem.ordemServico.numero }}
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <label class="pt-3 pl-4 ml-2 pb-2">
        Escolha os selos que serão vinculados:
      </label>
    </div>

    <div class="row">
      <div class="col">
        <label class="VincularSelo_subheader pl-3 mb-0">
          Registro atual
        </label>
      </div>
    </div>

    <div v-if="passoAtivo === 0">
      <div v-if="selosPendentesVinculacao.length > 0">
        <ListagemSelos :prop-selos="selosPendentesVinculacao"
                       :prop-registro-id="propRegistroId"
                       :prop-focus-selecionar-todos="true"
                       @selecionados="selosSelecionados" />
      </div>

      <div v-else>
        <label class="pt-3 pl-3">
          Nenhum selo encontrado neste registro para realizar a vinculação.
        </label>
      </div>
    </div>

    <ListagemSelos v-if="passoAtivo === 1 && selosPendentesVinculacao.filter(selo => selo.check).length > 0"
                   :prop-selos="selosPendentesVinculacao.filter(selo => selo.check)"
                   :prop-registro-id="propRegistroId"
                   :prop-read-only="true" />

    <div v-if="registrosSelecionados.length > 0">
      <div v-for="(registro, index) in registrosSelecionados"
           :key="`registro_selecionado_${index}`"
           class="mt-4">
        <HeaderBoxRegistro :prop-registro="registro" />

        <ListagemSelos v-if="passoAtivo === 0 && registro.selos"
                       :prop-selos="registro.selos"
                       :prop-registro-id="registro.registro_id"
                       :prop-focus-selecionar-todos="true"
                       @selecionados="selosSelecionados" />

        <ListagemSelos v-if="passoAtivo === 1 && registro.selosSelecionados"
                       :prop-selos="registro.selosSelecionados"
                       :prop-registro-id="registro.registro_id"
                       :prop-read-only="true" />
      </div>
    </div>

    <div v-if="passoAtivo === 0">
      <button :ref="`modalVinculacaoSelo_${_uid}`"
              v-b-modal="`modalVinculacaoSelo_${_uid}`"
              class="btn btn-sm btn-outline-primary btn-add-selo btn-block my-3"
              type="button"
              @click="modalVinculacaoSelo = true"
              @keyup.enter="modalVinculacaoSelo = true">
        <IconSvg class="icon-add icon--sm mr-1"
                 icon="add" />
        Adicionar selos de outro registro
      </button>

      <BuscaSelosOutrosRegistros v-if="modalVinculacaoSelo"
                                 :prop-registro-id="propRegistroId"
                                 :prop-cpf-registrado="propCpfRegistrado"
                                 :prop-nome-registrado="propNomeRegistrado"
                                 :prop-habilitacao="propHabilitacao"
                                 @voltar="modalVinculacaoSelo = false"
                                 @registroSelecionado="registroSelecionado" />
    </div>

    <div class="mt-4 mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block">
          <button ref="botaoVoltaVinculacao"
                  class="btn btn-sm btn-dark"
                  type="button"
                  @click="passoAtivo === 0 ? $emit('voltar') : backStep()">
            Voltar
          </button>
        </div>

        <div class="d-inline-block ml-2">
          <button class="btn btn-sm btn-primary"
                  type="button"
                  :disabled="selecionados.length === 0"
                  @click="passoAtivo === 0 ? nextStep() : finalizarVinculacao()">
            {{ passoAtivo === 0 ? 'Continuar' : 'Finalizar vinculação' }}
          </button>
        </div>
      </div>
    </div>

    <b-modal v-if="finalizarVinculacoes"
             :id="`finalizarVinculacoes_${_uid}`"
             :ref="`finalizarVinculacoes_${_uid}`"
             modal-class="FinalizarVinculacoes"
             body-class="FinalizarVinculacoes_body"
             header-class="FinalizarVinculacoes_header"
             :visible="true"
             hide-header
             hide-footer
             centered
             size="md"
             @hide="finalizarVinculacoes = false">
      <label class="FinalizarVinculacoes_titulo mt-3 ml-4">
        Gostaria de enviar ao TJ a lista de selos vinculados?
      </label>

      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block mt-3 mb-1">
          <button ref="botaoVincularDepois"
                  class="btn btn-sm FinalizarVinculacoes_botao-voltar pl-2"
                  type="button"
                  @click="vincular()">
            Deixar para mais tarde
          </button>
        </div>

        <div class="d-inline-block ml-2 mt-3 mb-1 mr-3">
          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="vincular(true)">
            Enviar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* services */
  import SelosService from '@/services/Registros/SelosService'

  /* components */
  import StepsForWizard from '@/components/SofiaRei/StepsForWizard'
  import HeaderBoxRegistro from '@/components/SofiaRei/Resumo/HeaderBoxRegistro'
  import ListagemSelos from '@/components/SofiaRei/Resumo/Selo/ListagemSelos'
  import BuscaSelosOutrosRegistros from '@/components/SofiaRei/Resumo/Selo/BuscaSelosOutrosRegistros'

  export default {
    name: 'VincularSelos',
    components: {
      StepsForWizard,
      HeaderBoxRegistro,
      ListagemSelos,
      BuscaSelosOutrosRegistros
    },
    props: {
      propSeloVinculador: { type: Object, default: () => ({}) },
      propRegistroId: { type: Number, default: () => null },
      propCpfRegistrado: { type: String, default: () => null },
      propNomeRegistrado: { type: String, default: () => null },
      propHabilitacao: { type: Object, default: () => null }
    },
    data () {
      return {
        // Variáveis para mudança de step do wizard
        passoAtivo: 0,
        passos: [
          { texto: 'Escolha de selos' },
          { texto: 'Resumo da vinculação' }
        ],

        // Selos do registro atual que estão pendentes de vinculação
        selosPendentesVinculacao: [],

        // Controle do modal de busca de registros com selo
        modalVinculacaoSelo: false,

        // Registros selecionas depois da busca de registros
        registrosSelecionados: [],

        // Array com objetos Registro Id de lista de selos selecionados
        selecionados: [],

        // Controle para finalizar a vinculação
        finalizarVinculacoes: false
      }
    },
    beforeMount () {
      this.getSelosPendentesVinculacao()
    },
    methods: {
      async getSelosPendentesVinculacao () {
        if (!this.propRegistroId) {
          this.selosPendentesVinculacao = []
          return
        }

        loader({ text: 'Buscando pendentes de vinculação...', active: true })

        const params = {
          registro_id: this.propRegistroId,
          num_selo_vinculador: this.propSeloVinculador.num_selo
        }

        try {
          this.selosPendentesVinculacao = await SelosService.getSelosRegistro(params)

          for (const seloPendenteVinculacao of this.selosPendentesVinculacao) {
            seloPendenteVinculacao.disableCheckbox = (!!seloPendenteVinculacao.vinculador || seloPendenteVinculacao.vinculacoes.length > 0)
          }

          // Atualizamos o controle de selos selecionados
          this.selosPendentesVinculacao.forEach(selo => selo.check = false)
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível encontrar os selos desse registro que ainda não foram vinculados'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)
        } finally {
          loader({ text: '', active: false })
        }
      },

      registroSelecionado (registro) {
        const indexSelecionadoRegistro = this.registrosSelecionados.findIndex(reg => reg.registro_id === registro.registro_id)

        if (indexSelecionadoRegistro >= 0) {
          objSwal.info.title = ''
          objSwal.info.text = 'Esse registro escolhido já foi selecionado'
          objSwal.info.html = ''

          return Swal.fire(objSwal.info)
        }

        for (const selo of registro.selos) {
          selo.disableCheckbox = (!!selo.vinculador || selo.vinculacoes.length > 0)
        }

        this.registrosSelecionados.push(registro)
        this.modalVinculacaoSelo = false
      },

      selosSelecionados ({ registroId, selos }) {
        const indexSelecionado = this.selecionados.findIndex(selecionado => selecionado.registroId === registroId)

        if (indexSelecionado < 0) {
          this.selecionados.push({
            registroId,
            selos
          })
          return
        }

        if (selos.length === 0) {
          this.selecionados.splice(indexSelecionado, 1)
          return
        }

        this.selecionados[indexSelecionado].selos = selos
      },

      backStep () {
        setTimeout(() => {
          this.passoAtivo = 0
        }, 100)
      },

      nextStep () {
        this.registrosSelecionados = this.registrosSelecionados.filter(registroSelecionado => {
          const selecionado = this.selecionados.find(selecionado => selecionado.registroId === registroSelecionado.registro_id)

          if (selecionado && selecionado.selos.length > 0) {
            registroSelecionado.selosSelecionados = selecionado.selos
            return registroSelecionado
          }
        })

        this.passoAtivo++

        setTimeout(() => {
          if (this.$refs['botaoVoltaVinculacao']) {
            this.$refs['botaoVoltaVinculacao'].focus()
          }
        }, 100)
      },

      finalizarVinculacao () {
        this.finalizarVinculacoes = true

        setTimeout(() => {
          if (this.$refs['botaoVincularDepois']) {
            this.$refs['botaoVincularDepois'].focus()
          }
        }, 100)
      },

      async vincular (enviarTJ = false) {
        const vinculacoes = []

        this.selecionados.forEach(selecionado => {
          selecionado.selos.forEach(selo => vinculacoes.push(selo.num_selo))
        })

        const data = {
          numSeloVinculador: this.propSeloVinculador.num_selo,
          vinculacoes,
          realizarEnvioVinculacaoTJ: enviarTJ
        }
        loader({ text: 'Aguarde...', active: true })

        try {
          const { vinculacoes } = await SelosService.vincularSelos(data)

          this.$root.$emit('bv::hide::modal', `finalizarVinculacoes_${this._uid}`)

          loader({ text: '', active: false })

          const vinculacoesComErro = vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)

          let texto = 'Vinculação realizada com sucesso!'

          if (vinculacoesComErro.length) {
            texto = vinculacoesComErro.length === 1 ? 'Ocorreu erro com alguma vinculação. ' : 'Ocorreu erro com algumas vinculações. '
            texto += 'Para verificar localize a data da vinculações na lista de selos vinculados e clique em editar para mais informações.'
          }

          objSwal.info.title = ''
          objSwal.info.text = texto
          objSwal.info.html = ''

          await Swal.fire(objSwal.info).then(() => this.$emit('finalizadoVinculacoes'))

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        } catch (e) {
          loader({ text: '', active: false })

          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível realizar a vinculação'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .VincularSelo {
    &_header {
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(8);
      background-color: $sinoreg-blue;
      color: $color-white;
      line-height: 35px;
    }

    &_title {
      font-size: pxToRem(17) !important;
      font-weight: 500;
    }

    &_subheader {
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(8);
      background-color: #f0ecec;
      line-height: 35px;
      width: 100%;
    }
  }

  .Listagem {
    width: 100%;
    font-size: 17.5px;

    &_titulo {
      background-color: $water-green-color;
      line-height: 37px;
    }

    &_switch {
      width: 7%;
    }

    &_selo {
      width: 35%;
    }

    &_os {
      width: 58%;
    }

    &_linha_clara {
      line-height: 35px;
      border-bottom: 1.5px solid $color-gray;
    }

    &_linha_escura {
      line-height: 35px;
      background-color: #f0ecec;
      border-bottom: 1.5px solid $color-gray;
    }

    &_padding_os {
      padding-bottom: 30px;
    }
  }

  .paginate {
    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .btn-add-selo:hover > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

  /deep/ .custom-control-label {
    vertical-align: text-top
  }

  /deep/ .modal-body {
    padding-top: 0;
  }

  .RegistroSelecionado {
    &--header {
      background-color: $sofiaRei-blue;
      min-height: 30px;
      display: flex;
      align-content: center;
      width: 100%;
    }

    &--tipo {
      font-size: 1rem;
    }

    &--table-width {
      flex: 0 0 28%;
      max-width: 28%;
    }

    &--table {
      font-size: 12px;
      & tr:first-child {
        border-bottom: 1px solid black;
      }

      & th, td {
        padding-left: 6px;
        padding-right: 6px;
      }
    }

    &--cartorio {
      font-size: 14px;
    }

    &_titulo_nascimento_casamento {
      flex: 0 0 10%;
      max-width: 10%;
    }

    &_titulo_cas_reg {
      flex: 0 0 16%;
      max-width: 16%;
    }

    &_titulo_hab {
      flex: 0 0 19%;
      max-width: 19%;
    }

    &_titulo_obito {
      flex: 0 0 6%;
      max-width: 6%;
    }
  }

  .FinalizarVinculacoes {
    &_titulo {
      font-size: 17.5px;
    }

    &_botao-voltar {
      background-color: #c8c4c4;
    }
  }
</style>
